import React from "react"
import { Button } from 'primereact/button';
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { Editor } from "primereact/editor";
import { Calendar } from "primereact/calendar";
import { Callbacks } from "jquery";
import { MultiSelect } from "primereact/multiselect";

import Utils from "../../utilities/Utils";
import { CallOutBox, FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { dateComparisonList, FR_SUFFIX, odsCallOutBoxs } from "../../entities/Constants";
import { DialogBase } from "./DialogBase";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
    ele: FormSectionElements;
    dialogVisible?: boolean;
    isEng: boolean;
    callback;
}

interface State {
    minDate: string;
    maxDate: string;
    minIsRelative: boolean;
    maxIsRelative: boolean;
    minComparison: string;
    maxComparison: string;
    minUnit: string;
    maxUnit: string;
    minAmount: string;
    maxAmount: string;
    dateError: boolean;
    minMissingFieldsError: boolean;
    maxMissingFieldsError: boolean;
    hasError: boolean;
    enableSearchFilter: boolean;
}

export class DialogForDateComponent extends DialogBase<Props, State> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

        const ele = this.props.ele

        let subSection = ele.parent as FormSubSections;
        this.dateTypeFieldList = subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < ele.Sequence);

        this.state = {
            minDate: ele.MinDate || '',
            maxDate: ele.MaxDate || '',
            minIsRelative: ele.MinDateRelative || false,
            maxIsRelative: ele.MaxDateRelative || false,
            minComparison: ele.MinDateComparison || '',
            maxComparison: ele.MaxDateComparison || '',
            minUnit: ele.MinDateUnit || '',
            maxUnit: ele.MaxDateUnit || '',
            minAmount: ele.MinDateAmount || '',
            maxAmount: ele.MaxDateAmount || '',
            dateError: false,
            minMissingFieldsError: false,
            maxMissingFieldsError: false,
            hasError: false,
            enableSearchFilter: ele.SearchFilter?.enabled || false,
        };
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Business Rule for " + this.props.ele.ENUTitle : "Business Rule for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    // COMPLETE DATE RESTRICTION OPTION
    //  includes: min + max options
    //            static / relative options for each
    //            toggle to switch between static / relative for each
    dateRestrictionHtml = () => {
        return (
            <div 
                style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    marginTop: '10px',
                    marginBottom: '10px',
                }}
            >
                {/* min limit */}
                {this.state.minIsRelative ? this.relativeDateRestrictionHtml(true) : this.staticDateRestrictionHtml(true)}
                {this.dateToggleHtml(true)}

                {/* min missing fields error message (RELATIVE ONLY) */}
                {this.state.minMissingFieldsError && (
                    <div style={{ color: 'red', marginLeft: '25%' }}>
                        Comparison, Unit, and Amount must all be filled or all empty.
                    </div>
                )}

                {/* max limit */}
                {this.state.maxIsRelative ? this.relativeDateRestrictionHtml(false) : this.staticDateRestrictionHtml(false)}
                {this.dateToggleHtml(false)}

                {/* max missing fields error message (RELATIVE ONLY) */}
                {this.state.maxMissingFieldsError && (
                    <div style={{ color: 'red', marginLeft: '25%' }}>
                        Comparison, Unit, and Amount must all be filled or all empty.
                    </div>
                )}

                {/* invalid dates error message (STATIC ONLY) */}
                {this.state.dateError && (
                    <div style={{ color: 'red', marginLeft: '25%' }}>
                        Minimum date must be before maximum date.
                    </div>
                )}
            </div>
        )
    }

    //
    // DATE RESTRICTION HELPERS
    //

    // STATIC DATE RESTRICTION FIELD
    //  calendar control allowing specific date to be selected for min / max date
    staticDateRestrictionHtml = (isMin: boolean) => {
        const min = this.state.minDate ? new Date(this.state.minDate) : null;
        const max = this.state.maxDate ? new Date(this.state.maxDate) : null;
        
        return (
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', marginBottom: '10px' }}>
                <label style={{ width: '25%' }}>{isMin ? 'Minimum Date' : 'Maximum Date'}</label>

                {/* calendar control */}
                <Calendar
                    showIcon
                    value={isMin ? min : max}
                    dateFormat='mm/dd/yy'
                    monthNavigator
                    yearNavigator
                    yearRange='1900:2100'
                    style={{ width: '60%' }}

                    onChange={(e) => {
                        const val = e.value as Date;
                        console.log(val)
                        if (isMin) {
                            // updates state
                            this.setState(
                                { minDate: val ? val.toLocaleDateString() : null },
                                () => {
                                    // if both are static, runs validation
                                    if (!this.state.maxIsRelative) this.setState({ dateError: this.isInvalidDates() });
                                }
                            );
                        } else {
                            this.setState(
                                { maxDate: val ? val.toLocaleDateString() : null },
                                () => {
                                    if (!this.state.minIsRelative) this.setState({ dateError: this.isInvalidDates() });
                                }
                            );
                        }
                    }}
                />

                {/* clear date button */}
                <Button
                    icon='pi pi-times'
                    style={{ 
                        alignItems: 'center',
                        background: 'none',
                        border: 'none',
                        color: '#555',
                        marginLeft: '.2%',
                        fontSize: '0.3rem',
                    }}
                    tooltip={isMin ? 'Clear minimum date' : 'Clear maximum date'}

                    onClick={() => {
                        if (isMin) {
                            this.setState({
                                minDate: null,
                                dateError: false,
                            });
                        } else {
                            this.setState({
                                maxDate: null,
                                dateError: false,
                            });
                        }
                    }}
                />
            </div>
        )
    }

    // RELATIVE DATE RESTRICTION FIELD
    //  dropdown + input fields allowing date relative to user's 'Today' (i.e. date on which user is filling form)
    //  example: date does not accept inputs earlier than 2 years before 'Today'
    //        -> Minimum Date | Comparison: Before Today | Unit: Years | Amount: 2
    //  example: date does not accept inputs later than 'Today'
    //        -> Maximum Date | Comparison: Today [UNIT AND AMOUNT FIELDS NOT RENDERED]
    relativeDateRestrictionHtml = (isMin: boolean) => {
        // comparison dropdown
        const comparisons = [
            { label: 'Before Today', value: 'before' },
            { label: 'Today', value: 'today' },
            { label: 'After Today', value: 'after' },
        ];

        // unit dropdown
        const units = [
            { label: 'Days', value: 'days' },
            { label: 'Weeks', value: 'weeks' },
            { label: 'Months', value: 'months' },
            { label: 'Years', value: 'years' },
        ];
    
        return ( 
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', marginBottom: '10px' }}>
                <label style={{ width: '25%' }}>{isMin ? 'Minimum Date' : 'Maximum Date'}</label>

                {/* comparison dropdown */}
                <Dropdown
                    value={isMin ? this.state.minComparison : this.state.maxComparison}
                    options={comparisons}
                    optionLabel='label'
                    optionValue='value'
                    placeholder='Comparison'
                    style={{ width: '19.5% '}}

                    onChange={(e) => {
                        const val = e.target.value;
                        if (isMin) {
                            // if comparison is 'today', clears amount and unit (unrendered) values
                            if (val === 'today') {
                                this.setState(
                                    {
                                        minComparison: val,
                                        minUnit: '',
                                        minAmount: '',
                                    },
                                    // checks for missing fields and renders err msg if date is not well-defined
                                    () => { this.hasMissingFields(isMin) }
                                );
                            // if comparison is not 'today', just update comparison value and check for missing fields
                            } else {
                                this.setState(
                                    { minComparison: val },
                                    () => { this.hasMissingFields(isMin) }
                                );
                            }
                        } else {
                            if (val === 'today') {
                                this.setState(
                                    {
                                        maxComparison: val,
                                        maxUnit: '',
                                        maxAmount: '',
                                    },
                                    () => { this.hasMissingFields(isMin) }
                                );
                            } else {
                                this.setState(
                                    { maxComparison: val },
                                    () => { this.hasMissingFields(isMin) }
                                );
                            }
                        }
                    }}
                />

                {/* unit dropdown */}
                {// only renders if comparison is NOT 'today'
                    ((isMin && this.state.minComparison !== 'today') ||
                    (!isMin && this.state.maxComparison !== 'today')) && (
                        <Dropdown
                            value={isMin ? this.state.minUnit : this.state.maxUnit}
                            options={units}
                            optionLabel='label'
                            optionValue='value'
                            placeholder='Units'
                            style={{ width: '19.5%', marginLeft: '0.75%' }}

                            onChange={(e) => {
                                const val = e.target.value;
                                if (isMin) {
                                    // updates state and renders err msg if date is not well-defined
                                    this.setState(
                                        { minUnit: val },
                                        () => { this.hasMissingFields(isMin) }
                                    );
                                } else {
                                    this.setState(
                                        { maxUnit: val },
                                        () => { this.hasMissingFields(isMin) }
                                    );
                                }
                            }}
                        />
                    )
                }

                {/* amount input */}      
                {// only renders if comparison is NOT 'today'
                    ((isMin && this.state.minComparison !== 'today') ||
                    (!isMin && this.state.maxComparison !== 'today')) && (
                        <InputText
                            value={isMin ? this.state.minAmount : this.state.maxAmount}
                            type='number'
                            placeholder='Amount'
                            style={{ width: '19.5%', marginLeft: '0.75%' }}

                            onChange={(e) => {
                                const val = e.target.value;
                                if (isMin) {
                                    // updates state and checks renders err msg if date is not well-defined
                                    this.setState(
                                        { minAmount: val },
                                        () => { this.hasMissingFields(isMin) }
                                    );
                                } else {
                                    this.setState(
                                        { maxAmount: val },
                                        () => { this.hasMissingFields(isMin) }
                                    );
                                }
                            }}
                        />
                    )
                } 

                {/* clear date button */}
                <Button
                    icon='pi pi-times'
                    style={{ 
                        alignItems: 'center',
                        background: 'none',
                        border: 'none',
                        color: '#555',
                        marginLeft: '.2%',
                        fontSize: '0.3rem',
                    }}
                    tooltip={isMin ? 'Clear minimum date' : 'Clear maximum date'}

                    onClick={() => {
                        if (isMin) {
                            this.setState({
                                minComparison: null,
                                minUnit: '',
                                minAmount: '',
                                minMissingFieldsError: false,
                            });
                        } else {
                            this.setState({
                                maxComparison: null,
                                maxUnit: '',
                                maxAmount: '',
                                maxMissingFieldsError: false,
                            });
                        }
                    }}
                />
            </div>
        )
    }

    // CHECKBOX TOGGLE
    //  toggles static / relative date limit visibility
    dateToggleHtml = (isMin: boolean) => {
        return (
            <div style={{ width: '100%', display: "flex", alignItems: 'center' }}>
                <div style={{ alignItems: 'center', marginBottom: '5px', width: '5%' }}>
                    <Checkbox
                        checked={isMin ? this.state.minIsRelative : this.state.maxIsRelative}
                        className='p-checkbox'

                        onChange={(e) => {
                            // if checked, becomes relative and clears static value
                            if (e.checked) {
                                if (isMin) {
                                    this.setState({
                                        minDate: '',
                                        minIsRelative: true,
                                    });
                                } else {
                                    this.setState({
                                        maxDate: '',
                                        maxIsRelative: true,
                                    });
                                }
                            // if unchecked, becomes static and clears relative values
                            } else {
                                if (isMin) {
                                    this.setState({
                                        minComparison: '',
                                        minUnit: '',
                                        minAmount: '',
                                        minIsRelative: false,
                                        minMissingFieldsError: false,
                                    });
                                } else {
                                    this.setState({
                                        maxComparison: '',
                                        maxUnit: '',
                                        maxAmount: '',
                                        maxIsRelative: false,
                                        maxMissingFieldsError: false,
                                    });
                                }
                            }
                            // clears err msgs upon change as all field values are cleared
                            this.setState({ dateError: false });
                        }}
                    />
                </div>

                <div style={{ display: 'flex', marginLeft: '0.3%', alignItems: 'center' }}>Set as relative date</div>
            </div>
        )
    }

    //
    // VALIDATION FUNCTIONS
    //

    // date validation for two static dates
    isInvalidDates = () => {
        const min = this.state.minDate ? new Date(this.state.minDate) : null;
        const max = this.state.maxDate ? new Date(this.state.maxDate) : null;
        console.log(min, max)
        
        // checks if static min date comes after max date
        if (min && max && min > max) return true;
        return false;
    }

    // checks if relative date is only partially filled
    hasMissingFields = (isMin: boolean) => {
        const comparison = isMin ? this.state.minComparison : this.state.maxComparison;
        const unit = isMin ? this.state.minUnit : this.state.maxUnit;
        const amount = isMin ? this.state.minAmount : this.state.maxAmount;

        const isIncomplete = comparison !== 'today' && (!comparison || !unit || !amount) && !(!comparison && !unit && !amount);
        
        if (isMin) {
            this.setState({ minMissingFieldsError: isIncomplete });
        } else {
            this.setState({ maxMissingFieldsError: isIncomplete });
        }
    }

    getSummaryListColumnOptions = () => {
        const options = [{
            label: this.props.isEng ? 'No summary list filter' : 'Pas de filtre summary list',
            value: null
        }];

        const root = getRootComponent(this.props.ele);
        const sections = root?.ListOfFormSections ?? [];

        sections.forEach((section: FormSections) => {
            section?.ListOfFormSubSections?.forEach((subSection: FormSubSections) => {
                subSection?.ListOfFormSectionElements?.forEach((element: FormSectionElements) => {
                    // Support both SummaryList and PagedSummaryList
                    if ((element?.Datatype === "SummaryList" || element?.Datatype === "PagedSummaryList") && element.subSectionList?.length) {
                        const summaryTitle = this.props.isEng ? element.ENUTitle : element.FRATitle;
                        const summaryId = element.Id;

                        // Add option for custom column (any field from API response)
                        options.push({
                            label: `${summaryTitle || summaryId || 'Summary List'} - (Custom column)`,
                            value: `${summaryId}|__CUSTOM__`
                        });

                        const columns = element.subSectionList[0]?.ListOfFormSectionElements ?? [];
                        columns.forEach((column: FormSectionElements) => {
                            const columnKey = column?.LoadBindName;
                            if (!columnKey) return;
                            const columnTitle = this.props.isEng ? column.ENUTitle : column.FRATitle;
                            options.push({
                                label: `${summaryTitle || summaryId || 'Summary List'} - ${columnTitle || columnKey}`,
                                value: `${summaryId}|${columnKey}`
                            });
                        });
                    }
                });
            });
        });

        return options;
    };

    getSummaryListColumnOptionsForSelectedSummary = () => {
        const allOptions = this.getSummaryListColumnOptions();
        const selectedSummaryKey = (this.props.ele as any)?.filterSummaryListId;
        if (!selectedSummaryKey) return allOptions;
        return allOptions.filter(opt => {
            if (!opt?.value) return true;
            return typeof opt.value === 'string' && opt.value.startsWith(`${selectedSummaryKey}|`);
        });
    };

    otherPreviousDateFields = () => {
        let htmlString = [];

        htmlString.push(
            <div>
                {this.updateBindingFieldHtml()}

                {this.questionHintHtml()}
            
                {this.emptyErrorMessageHtml()}
              
                {this.errorMessageHtml()}

                {this.dateCompareDisplayHtml()}

                {this.dateRestrictionHtml()}

                {this.dateFormatHtml()}

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"DateContainerClass" + this.props.ele.Sequence}>Date Field Style</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown
                            id={"DateContainerClass" + this.props.ele.Sequence}
                            className="ontario-dropdown-small"
                            options={[
                                { label: 'Standard (ontario-date)', value: 'ontario-date' },
                                { label: 'Input Style (ontario-date-input)', value: 'ontario-date-input' }
                            ]}
                            value={(this.props.ele as any).DateContainerClass || 'ontario-date'}
                            onChange={(e) => {
                                (this.props.ele as any).DateContainerClass = e.value;
                                this.props.callback();
                            }}
                            placeholder="Select date field style"
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>

                {this.hintExpansionTitleHtml()}

                {this.calloutBoxHtml()}
                {this.fieldSizeHtml()}

                {this.scriptHtml()}

                {this.maskSummaryHtml()}

                {this.indentHtml()}

                {this.excludeFromPayload()}

                {/* Enable Date Search checkbox */}
                <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"enable_search_button_" + this.props.ele.Sequence}>
                            Enable Date Search:
                        </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            id={"enable_search_button_" + this.props.ele.Sequence}
                            checked={this.state.enableSearchFilter}
                            onChange={(e) => {
                                this.setState({ enableSearchFilter: e.checked });
                            }}
                        />
                    </div>
                </div>

                {this.state.enableSearchFilter && (
                    <>
                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>
                                <label htmlFor={`summary_list_filter_${this.props.ele.Sequence}`}>Summary list filter</label>
                            </div>
                            <div style={{ width: '60%' }}>
                                {/* @ts-ignore */}
                                <MultiSelect
                                    id={`summary_list_filter_${this.props.ele.Sequence}`}
                                    className="ontario-dropdown-small"
                                    optionLabel="label"
                                    optionValue="value"
                                    options={this.getSummaryListColumnOptionsForSelectedSummary()}
                                    value={this.props.ele.filterSummaryListId
                                        ? (Array.isArray((this.props.ele as any).filterSummaryListColumns) && (this.props.ele as any).filterSummaryListColumns.length
                                            ? (this.props.ele as any).filterSummaryListColumns.map((col: string) => `${this.props.ele.filterSummaryListId}|${col}`)
                                            : (this.props.ele.filterSummaryListColumn ? [`${this.props.ele.filterSummaryListId}|${this.props.ele.filterSummaryListColumn}`] : []))
                                        : []}
                                    placeholder="Select summary list columns"
                                    style={{ width: '100%' }}
                                    display="chip"
                                    onChange={(e) => {
                                        const elementAny = this.props.ele as any;
                                        const rawValues = e.value ?? [];
                                        const selectedValues: string[] = (Array.isArray(rawValues) ? rawValues : [rawValues]).filter(v => typeof v === 'string');
                                        if (!selectedValues.length) {
                                            elementAny.filterSummaryListId = null;
                                            elementAny.filterSummaryListColumn = null;
                                            elementAny.filterSummaryListColumns = [];
                                            this.props.callback();
                                            return;
                                        }
                                        const [firstSummaryId] = selectedValues[0].split('|');
                                        const scopedValues = selectedValues.filter(v => v.startsWith(`${firstSummaryId}|`));
                                        const columnNames = scopedValues.map(val => val.split('|')[1]).filter(Boolean);
                                        elementAny.filterSummaryListId = firstSummaryId;
                                        elementAny.filterSummaryListColumns = columnNames;
                                        elementAny.filterSummaryListColumn = columnNames[0] ?? null;
                                        this.props.callback();
                                    }}/>
                            </div>
                        </div>

                        {this.props.ele.filterSummaryListId && (
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>
                                    <label htmlFor={`custom_filter_column_${this.props.ele.Sequence}`}>Custom filter column</label>
                                </div>
                                <div style={{ width: '60%' }}>
                                    {/* @ts-ignore */}
                                    <InputText
                                        className="ontario-input"
                                        id={`custom_filter_column_${this.props.ele.Sequence}`}
                                        placeholder="e.g., receivedDate (from API response)"
                                        value={this.props.ele.filterSummaryListColumn ?? ''}
                                        onChange={(e) => {
                                            const elementAny = this.props.ele as any;
                                            elementAny.filterSummaryListColumn = e.target.value;
                                            elementAny.filterSummaryListColumns = elementAny.filterSummaryListColumn ? [elementAny.filterSummaryListColumn] : [];
                                            this.props.callback();
                                        }}/>
                                    <small style={{ color: '#666', display: 'block', marginTop: '4px' }}>
                                        Enter any field name from the API response data
                                    </small>
                                </div>
                            </div>
                        )}
                    </>
                )}

            </div>
        )
        return htmlString;
    }

    // resets state with latest data from props when dialog becomes visible
    componentDidUpdate(prevProps: Props) {
        const ele = this.props.ele;
        if (!prevProps.dialogVisible && this.props.dialogVisible) {
            this.setState({
                minDate: ele.MinDate || '',
                maxDate: ele.MaxDate || '',
                minIsRelative: ele.MinDateRelative || false,
                maxIsRelative: ele.MaxDateRelative || false,
                minComparison: ele.MinDateComparison || '',
                maxComparison: ele.MaxDateComparison || '',
                minUnit: ele.MinDateUnit || '',
                maxUnit: ele.MaxDateUnit || '',
                minAmount: ele.MinDateAmount || '',
                maxAmount: ele.MaxDateAmount || '',
                dateError: false,
                minMissingFieldsError: false,
                maxMissingFieldsError: false,
                hasError: false,
                enableSearchFilter: ele.SearchFilter?.enabled || false,
            });
        }
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" 
                    onClick={() => {
                        if (this.state.dateError || this.state.minMissingFieldsError || this.state.maxMissingFieldsError) {
                            this.setState({ hasError: true });
                        }
                        else {
                            const {
                                minDate, minIsRelative, minComparison, minUnit, minAmount,
                                maxDate, maxIsRelative, maxComparison, maxUnit, maxAmount,
                                enableSearchFilter,
                            } = this.state;

                            const ele = this.props.ele;
                            Object.assign(ele, {
                                MinDate: minDate,
                                MinDateRelative: minIsRelative,
                                MinDateComparison: minComparison,
                                MinDateUnit: minUnit,
                                MinDateAmount: minAmount,
                                MaxDate: maxDate,
                                MaxDateRelative: maxIsRelative,
                                MaxDateComparison: maxComparison,
                                MaxDateUnit: maxUnit,
                                MaxDateAmount: maxAmount,
                            });

                            if (enableSearchFilter) {
                                if (!ele.SearchFilter) {
                                    ele.SearchFilter = {};
                                }
                                ele.SearchFilter.enabled = true;
                            } else {
                                if (ele.SearchFilter) {
                                    ele.SearchFilter.enabled = false;
                                }
                            }
                            
                            this.props.callback(false);
                        }
                    }} 
                />

                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />
                {this.state.hasError && (
                    <div style={{ color: 'red', marginTop: '4px' }}>
                        There are unresolved errors.
                    </div>
                )}
            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
